export const DRIVING_STATUS = 'DRIVING';
export const STOP_STATUS = 'STOP';
export const NO_GPS_STATUS = 'NO_GPS';
export const NO_GSM_STATUS = 'NO_GSM';
export const PRIVATE_STATUS = 'PRIVATE';
export const UNKNOWN_STATUS = 'UNKNOWN';
